<template>
    <div>

    <div class="row">
        <div class="col-12">
            <div class="panel-sub-heading headingLarge" v-if="!is_reviewing">
                <span v-if="!isSoleTrader" class="h5 display-6 markedBottom bold">{{ lang('principals') }}</span>
                <span v-else class="h5 display-6 markedBottom bold">{{ lang('sole_trader_principal') }}</span>
                <span v-if="isPiiDataMaskedDocument" class="float-right float-end">
                    <a class="btn btn-sm btn-default btn-with-label" @click="unmaskHandler">
                        <span class="btn-label"><i class="fas fa-pencil-alt"></i></span>
                        {{lang('unmask')}}
                    </a>
                </span>
            </div>
        </div>
        <div class="col-12">
            <template v-if="objectIsNotEmpty(owners) && owners.length > 0">
    <div v-for="(owner, index) in owners" :id="`accordion_${index}`">
        <div :id="`director_${index}`" :key="index" class="card">
            <div class="card-header cursorPointer"
                 :id="`heading_${index}`"
                 @click="toggleAccordionSection(owner)"
                 data-bs-toggle="collapse"
                 :data-bs-target="`#collapse_${index}`"
                 aria-expanded="true"
                 :aria-controls="`collapse_${index}`">
                <h5 class="mb-0">
                    <span v-if="owner.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                    <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                    {{getPrincipalFullName(owner)}}
                    {{owner.ownership_perc !== '' ? owner.ownership_perc+'%' : ''}}
                    <span class="float-right float-end">
                        <!-- In Bootstrap 4 the class 'badge' was removed therefore 'badge badge-primary' wont work. -->
                        <!-- Was suggested to replace badge-primary with bg-primary -->
                         <span v-if="owner.is_bank_id_verified == '1'" class="badge bg-primary">{{ lang('verified') }}</span>
                    </span>
                </h5>
            </div>
            <div :id="`collapse_${index}`" :class="'collapse'" :data-owner_id="owner.owner_ref" :aria-labelledby="`heading_${index}`"
                 :data-bs-parent="`#accordion_${index}`">
            <div class="card-body">
                <bank-id-verify v-if="isOpenApplication && merchantToUploadDocument && canUseBankIdVerify && owner.is_signatory == '1' && (user.email == owner.owner_email)"
                                :acr-values-options="criiptoAcrValues"
                                :parameters="parameters.PROVIDER_CONFIGS_PARAM.criipto"
                                :application_reference="merchant.application_reference"
                                :owner_ref="owner.owner_ref"
                                :owner="owner"
                                @input="updateBankID($event, owner.owner_ref)"
                                v-model="owner.verification_type"
                ></bank-id-verify>
                <bank-id-verify v-else-if="!isOpenApplication && showEditDocumentSignatory && canUseBankIdVerify && owner.is_signatory == '1' && (user.email == owner.owner_email)"
                                :acr-values-options="criiptoAcrValues"
                                :parameters="parameters.PROVIDER_CONFIGS_PARAM.criipto"
                                :application_reference="merchant.application_reference"
                                :owner_ref="owner.owner_ref"
                                :owner="owner"
                                @input="updateBankID($event, owner.owner_ref)"
                                v-model="owner.verification_type"
                ></bank-id-verify>
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-12" ref="block_personal_information">
                        <div class="row">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall ">
                                    <span class="markedBottom">{{lang('personal_information')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 col-12" v-show="displayMainPrincipal">
                                        <np-entry class="ps-0"
                                                  :id="`is_main_principal_${index}`"
                                                  :label="lang('is_main_principal')"
                                                  ref="is_main_principal"
                                                  mode="inline"
                                                  :model-value="owner.is_main_principal"
                                                  :formatter="formatBooleanOption">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <np-entry :id="`is_signatory_${index}`"
                                                  :label="lang('is_signatory')"
                                                  ref="is_signatory"
                                                  mode="inline"
                                                  :model-value="owner.is_signatory"
                                                  :formatter="formatBooleanOption">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <np-entry :id="`is_beneficial_owner_${index}`"
                                                :label="lang('is_beneficial_owner')"
                                                ref="is_beneficial_owner"
                                                mode="inline"
                                                :model-value="owner.is_beneficial_owner"
                                                :formatter="formatBooleanOption">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <np-entry :id="`is_responsible_party_${index}`"
                                                :label="lang('is_responsible_party')"
                                                ref="is_responsible_party"
                                                mode="inline"
                                                :model-value="owner.is_responsible_party"
                                                :formatter="formatBooleanOption">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12" v-show="displayOwner">
                                        <np-entry
                                            ref="is_owner"
                                            :id="`is_owner_${index}`"
                                            :label="lang('is_owner')"
                                            mode="inline"
                                            :formatter="formatBooleanOption"
                                            :model-value="owner.is_owner">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12">
                                        <np-entry
                                            ref="is_director"
                                            :id="`is_director_${index}`"
                                            :label="lang('is_director')"
                                            :no-wrapper="true"
                                            mode="inline"
                                            :formatter="formatBooleanOption"
                                            :model-value="owner.is_director">
                                        </np-entry>
                                    </div>
                                </div>
                                <div class="row" ref="owner_title">
                                    <div class="col-lg-7 col-md-8 col-sm-12">
                                        <np-entry :id="`owner_title_${index}`"
                                                :label="lang('field_title')"
                                                mode="inline"
                                                :formatter="formatTitle"
                                                :model-value="owner.owner_title === 'other' ? owner.other_owner_title : owner.owner_title">
                                        </np-entry>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6  col-12" ref="owner_first_name">
                                        <np-entry
                                                :id="`owner_first_name_${index}`"
                                                :label="lang('field_first_name')"
                                                mode="inline"
                                                :model-value="owner.owner_first_name">
                                        </np-entry>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-12" ref="owner_second_name">
                                        <np-entry
                                            :id="`owner_second_name_${index}`"
                                            :label="lang('field_middle_name')"
                                            mode="inline"
                                            :model-value="owner.owner_second_name">
                                        </np-entry>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-12" ref="owner_surname">
                                        <np-entry :id="`owner_surname_${index}`"
                                                  :label="lang('owner_surname')"
                                                mode="inline"
                                                :model-value="owner.owner_surname">
                                        </np-entry>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-12" ref="contact_dob">
                                        <np-entry
                                                :label="lang('date_of_birth')"
                                                mode="inline"
                                                :model-value="owner.contact_dob"
                                                :formatter="formatDate">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12" ref="owner_nationality">
                                        <np-entry
                                                :label="lang('field_nationality')"
                                                mode="inline"
                                                :formatter="formatNationality"
                                                :model-value="owner.owner_nationality">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12" ref="owner_pesel" v-if="principalIsPolishResident(owner)">
                                        <np-entry
                                                :label="lang('pesel')"
                                                mode="inline"
                                                :model-value="owner.owner_pesel">
                                        </np-entry>
                                    </div>
                                </div>

                                <div class="row" v-if="!isSoleTrader">
<!--                                    <div class="col-md-6 col-12" ref="owner_position">-->
<!--                                        <np-entry  :id="`owner_position_${index}`"-->
<!--                                            :label="lang('field_position_in_company')"-->
<!--                                            :value="owner.owner_position"-->
<!--                                            mode="inline"-->
<!--                                            :formatter="formatPosition">-->
<!--                                        </np-entry>-->
<!--                                    </div>-->
                                    <div class="col-md-6 col-12" ref="ownership_perc">
                                        <np-entry
                                                :id="`ownership_perc_${index}`"
                                                :label="lang('field_owner_percentage')"
                                                mode="inline"
                                                ref="ownership_perc"
                                                :model-value="owner.ownership_perc">
                                        </np-entry>
                                    </div>
                                    <div class="col-md-6 col-12" ref="directional_ownership_type">
                                        <np-entry
                                            :id="`directional_ownership_type_${index}`"
                                            :label="lang('directional_ownership_type')"
                                            mode="inline"
                                            ref="directional_ownership_type"
                                            :formatter="formatDirectionalOwnershipType"
                                            :model-value="owner.directional_ownership_type">
                                        </np-entry>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-12 address_Panel">
                        <div class="row" ref="block_current_address">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span  class="markedBottom">{{ lang('current_home_address') }}</span>
                                </div>
                            </div>
                            <div class="col-md-12 mt-3">
                                <p v-html="formatAddress(owner.contacts[0], true)"></p>
                            </div>
                            <div class="col-12" ref="date_from" v-show="hideLivedAtAddress">
                                <np-entry
                                        :label="lang('lived_at_this_since')"
                                        mode="inline"
                                        :model-value="owner.contacts[0].date_from">
                                </np-entry>
                            </div>
                        </div>
                        <div class="row" ref="block_finder_current_address">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                  <span class="markedBottom">{{ lang('current_home_address') }}</span>
                                </div>
                            </div>
                            <div class="col-md-12 mt-3">
                                <p v-html="formatAddress(owner.contacts[0], true)"></p>
                            </div>
                            <div class="col-12" ref="finder_date_from" v-show="hideLivedAtAddress">
                                <np-entry
                                    :label="lang('lived_at_this_since')"
                                    mode="inline"
                                    :model-value="owner.contacts[0].date_from">
                                </np-entry>
                            </div>
                        </div>
                        <div class="row" ref="block_personal_information">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall"><span
                                        class="markedBottom">{{ lang('contact') }}</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-12" ref="owner_email">
                                <np-entry
                                        :id="`email_address_${index}`"
                                        :label="lang('field_email')"
                                        mode="inline"
                                        :model-value="owner.owner_email">
                                </np-entry>
                            </div>
                            <div class="col-md-6 col-12" ref="owner_phone">
                                <np-entry
                                    :label="lang('phone_number')"
                                    mode="inline"
                                    :model-value="`${formatPhoneCode(owner.owner_phone_code)} ${owner.owner_phone_no}`">
                                </np-entry>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
            </template>
        </div>
    </div>
        <div class="row mt-4" v-if="!is_reviewing" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        NPCheckBox, NPEntry,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import {Owner} from "../../../entities";
    import applicationMixin from "../../../utils/application-mixin";
    import documentMixin from '../../../utils/document-mixin.js';
    import principalMixin from '../../../utils/principal-mixin.js';
    import navigationMixin from "../../../utils/navigation-mixin";
    import utilMixin from "../../../utils/mixins";
    import BankIdVerify from "../../../components/bank-id-verify.vue";
    import * as types from "../../../stores/constants";
    import useModuleStore from "../../../stores";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "viewPrincipal",
        mixins:[utilMixin, applicationMixin, documentMixin, principalMixin, navigationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-entry': NPEntry,
            'np-skeleton': NPSkeleton,
            'bank-id-verify': BankIdVerify
        },
        data() {
            return {
                current_index: '',
                personnel_mode: 2,
                page_config_template: 'SelfPrincipals',
            }
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        created() {
        },
        metaInfo() {
            return {
                title: this.lang('tab_principals')
            }
        },
        computed: {
            owners: function () {
                return this.merchant.owners;
            },
            showBeneficialOwner: function (){
                //everything but public limited
                return this.merchant.ownership_entity_type !== this.business_types.PUBLIC_LIMITED_COMPANY;
            },
            showResponsibleParty: function (){
                // only for limited
                return this.merchant.ownership_entity_type === this.business_types.LIMITED
            },
            showDirector: function (){
                return !this.isSoleTrader && !this.isPartnership
            },
            displayMainPrincipal: function (){
                return false;
            },
            displayOwner: function (){
                return false;
            },
            hideLivedAtAddress: function(){
                return false;
            },
            merchantToUploadDocument: function (){
                return this.merchant.merchant_to_upload_document == '1'
            },

        },
        mounted() {
            this.pageConfig = this.page_config[this.page_config_template];

            this.resetAccordionIcon();
            this.showAccordion(0); //open first principal

            let vm = this;
            useModuleStore().commit(types.TOGGLE_LOADING, true);
            setTimeout(function () {
                vm.runPageConfig(vm.page_config[vm.page_config_template]);
                useModuleStore().commit(types.TOGGLE_LOADING, false);
            }, 1000);

            if (this.objectIsNotEmpty(this.owners)) {
                this.owners.forEach(owner => {
                    vm.setOtherTitle(owner, true, true)
                })
            }
        },
        beforeRouteEnter: function (to, from, next) {
            next(vm => {
                // let same_url = vm.$route.path.includes(to.fullPath);

                // if (!vm.isPiiMasked && vm.cannotBeInEditFlow && !same_url) {
                //     vm.$router.push({path: `/application/view/${vm.$route.params.application_reference}/business_details/principals/`});
                // }
                // else {
                    vm.resetAccordionIcon();
                    vm.showAccordion(0)
                // }
            })
        },
        methods: {
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path:  this.application_root_path +'business_details/trading/'})
            },
            currentSignatoryNeedsUpload: function () {
                let should_upload = false
                let current_owner = this.merchant.owners.find(owner => owner.owner_email === this.user.email)

                if (current_owner && current_owner.is_signatory == '1') {
                    const has_idpal_set = (this.isIdPalWorkflowConfigured && current_owner.idpal_verification && current_owner.idpal_verification == '1');
                    const has_bankid_set = (this.canUseBankIdVerify && current_owner.is_bank_id_verified && current_owner.is_bank_id_verified == '1');
                    const is_id_verified_without_doc = (has_idpal_set || has_bankid_set);

                    let current_owner_proof_of_id = this.merchant.documents.find(doc => doc.selected_entity_id === current_owner.owner_ref)

                    if (!current_owner_proof_of_id && !is_id_verified_without_doc) {
                        should_upload = true
                    }
                }
                return should_upload
            },
            doContinue: function (){
                let vm = this;
                let unfinished_application_exist = !!this.unfinished_application;
                let unfinished_application = unfinished_application_exist ? this.unfinished_application : null;

                //check if validation is needed
                vm.initDocumentValidationRulesByConfig();
                let needs_document_validation = Object.values(vm.document_categories_validation_rules).length > 0;
                let signer_needs_document_validation = vm.getSignerDocumentCategories().length > 0;

                let principal_is_bank_id_verified = this.merchant.owners.filter(owner => owner.is_bank_id_verified == '1')

                //can skip documents if a principal is bank id verified.
                // if(principal_is_bank_id_verified.length > 0 ){
                //     needs_document_validation = false
                // }

                let path_to = vm.application_root_path;

                if ((unfinished_application && vm.isMerchantViewAndUpdateDocument(unfinished_application)) || this.currentSignatoryNeedsUpload()) {
                  if (needs_document_validation) {
                      if (vm.isPiiDataMaskedDocument) {
                          path_to += 'upload_documents_mask/';
                      } else {
                          path_to += 'upload_documents/';
                      }
                  } else if (vm.isSignerUser && signer_needs_document_validation) {
                      if (vm.isPiiDataMaskedDocument) {
                          path_to += 'upload_documents_mask/';
                      } else {
                          path_to += 'upload_documents/';
                      }
                  } else {
                    path_to += 'review/';
                  }
                } else {
                    if (vm.isPiiDataMaskedDocument && needs_document_validation) {
                        path_to += 'documents_mask/';
                    } else {
                        path_to += needs_document_validation ? 'documents/' : 'review/';
                    }
                }
                vm.$router.push({path: path_to})
            },
            principalIsPolishResident: function (owner) {
                let is_polish_resident = owner.contacts[0].country_code === '616';

                if (!is_polish_resident) {
                    owner.owner_pesel = '';
                }

                return is_polish_resident;
            },
            updateBankID: function (value, owner_ref) {
                let vm = this;
                if (value === 'DOCUMENT') {
                    let payload = {
                        'code': 'DOCUMENT', //used to bypass validation
                        'owner_ref': owner_ref,
                        'application_reference': this.merchant.application_reference,
                        'country_code': vm.getIso3FromCountryCode(vm.baseCountryCode),
                        'verification_type': value,
                        'redirect_uri' : 'upload_documents/' //used to bypass validation
                    };

                    //move to next step.
                    useApplicationStore()[types.SAVE_BANK_ID_PRINCIPAL_DATA](payload).then(response => {
                        if (response && response.data && response.data.result === 'SUCCESS'){
                            vm.notifySuccess(vm.lang('principals_updated_successfully'));
                            //redirect to principal page, fire criipto ajax call
                            // vm.redirectToPrincipalPage(application_ref, current_action);
                            window.location.reload();
                        }
                    }).catch(error => {
                        console.log(error);
                        window.location.reload();
                    });
                }
            },
        },
        watch: {
        }

    }
</script>

<style scoped>

</style>
